module.exports = __webpack_public_path__ + "img/5.f962200d.png";